<template>
  <svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 6.15625C0.500364 1.86484 5.39982 -0.866595 9.36621 1.20312L9.74707 1.41797L48.7676 25.2617C52.2967 27.4182 52.4071 32.2009 49.0986 34.5215L48.7676 34.7383L9.74707 58.582C5.72117 61.0416 0.500378 58.2735 0.5 53.8438V6.15625Z"
      fill="#F7F7F7"
      stroke="#C6C6C6"
    />
  </svg>
</template>
